import React, { useState, createContext, useContext, useEffect } from 'react';
import { AuthHelper } from '../../../common/helper';
import { Private, Job, Payment } from '../../firestore_model';
import { useInjection } from '../../../di_container/InjectionProvider';
export const _ = () => {
    const { container } = useInjection();
    const [jobClinic, setJobClinic] = useState();
    const [privateClinic, setPrivateClinic] = useState();
    const [paymentClinic, setPaymentClinic] = useState();
    const [error, setError] = useState();
    useEffect(() => {
        const authRepository = container.resolve('AuthRepository');
        const listener = authRepository.onAuthListener(async (user) => {
            var _a;
            let jobListener;
            let privateListener;
            let paymentListener;
            if (user != null) {
                const userId = user.uid;
                const tokenResult = await ((_a = user) === null || _a === void 0 ? void 0 : _a.getIdTokenResult(true));
                if (AuthHelper.isUserType('clinicUser', tokenResult)) {
                    // Job
                    jobListener = Job.Clinic.collectionReference()
                        .doc(userId)
                        .onSnapshot(async (snapshot) => {
                        const data = Job.Clinic.fromSnapshot(snapshot);
                        console.log('listen jobClinic');
                        setJobClinic(data);
                    });
                    // Private
                    privateListener = Private.Clinic.collectionReference()
                        .doc(userId)
                        .onSnapshot(async (snapshot) => {
                        const data = Job.Clinic.fromSnapshot(snapshot);
                        console.log('listen privateClinic');
                        setPrivateClinic(data);
                    });
                    // payment
                    paymentListener = Payment.Clinic.collectionReference()
                        .doc(userId)
                        .onSnapshot(async (snapshot) => {
                        const data = Payment.Clinic.fromSnapshot(snapshot);
                        console.log('listen paymentClinic');
                        setPaymentClinic(data);
                    });
                    return;
                }
            }
            if (jobListener !== undefined) {
                jobListener();
            }
            if (privateListener !== undefined) {
                privateListener();
            }
            if (paymentListener !== undefined) {
                paymentListener();
            }
            setJobClinic(undefined);
            setPrivateClinic(undefined);
            setPaymentClinic(undefined);
        }, (error) => {
            setError(new Error(error.message));
        });
        return () => {
            listener();
        };
    }, []);
    return {
        privateClinic,
        jobClinic,
        paymentClinic,
        error,
    };
};
export const ClinicContext = createContext({});
export const ClinicProvider = ({ children }) => {
    const { privateClinic, jobClinic, paymentClinic, error } = _();
    return (React.createElement(ClinicContext.Provider, { value: {
            privateClinic,
            jobClinic,
            paymentClinic,
            error,
        } }, children));
};
export const useClinicUser = () => useContext(ClinicContext);
